import './App.css'
import { SnackbarProvider } from 'notistack'
import AppAuthProvider from './components/providers/AppAuthProvider/AppAuthProvider'
import Layout from './components/layout/Layout'
import { BrowserRouter } from 'react-router-dom'
import AppRouting from './components/providers/AppRouting'
import ActivationObjectProvider from './components/providers/ActivationObjectProvider/ActivationObjectProvider'
import AppQueryProvider from './components/providers/AppQueryProvider'
import { cs } from 'date-fns/locale'

import { ThemeProvider } from '@mui/material'
import { theme } from './styles/theme'
import { LocalizationProvider } from '@mui/lab'
import AdapterDateFns from '@mui/lab/AdapterDateFns'

const App = () => {
    return (
        <BrowserRouter>
            <AppQueryProvider>
                <ThemeProvider theme={theme}>
                    <SnackbarProvider>
                        <AppAuthProvider>
                            <ActivationObjectProvider>
                                <LocalizationProvider locale={cs} dateAdapter={AdapterDateFns}>
                                    <Layout>
                                        <AppRouting />
                                    </Layout>
                                </LocalizationProvider>
                            </ActivationObjectProvider>
                        </AppAuthProvider>
                    </SnackbarProvider>
                </ThemeProvider>
            </AppQueryProvider>
        </BrowserRouter>
    )
}

export default App
